import { createContext } from 'react';
import { MessageType } from '../../components/atoms/Messages/Message.tsx';
import { Overbygning } from '../Utils/types/Overbygning.ts';

export type OverbygningWithErrors = {
	overbygning: Overbygning;
	feilmelding?: MessageType[];
};

export type OverbygningContextType = {
	overbygningWithErrors: OverbygningWithErrors[];
	updateFeilmeldinger: (feilmeldinger: MessageType[], index: number) => void;
	addOverbygning: (overbygning: Overbygning) => void;
	deleteOverbygning: (index: number) => void;
	updateOverbygninger: (overbygninger: Overbygning, index: number) => void;
};

export const OverbygningContext = createContext<OverbygningContextType>({
	overbygningWithErrors: [],
	addOverbygning: () => undefined,
	deleteOverbygning: () => undefined,
	updateOverbygninger: () => undefined,
	updateFeilmeldinger: () => undefined,
});
